/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { DependencyObject } from "./DependencyObject";
import { DVSR } from "./DVSR";
import { markType } from "./type";
/**
 * @hidden
 */
var SRProvider = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SRProvider, _super);
    function SRProvider(a) {
        var _this = _super.call(this) || this;
        _this.j = null;
        _this.k = null;
        _super.prototype.toString.call(_this);
        _this.k = a;
        _this.j = new DVSR(a);
        return _this;
    }
    Object.defineProperty(SRProvider.prototype, "l", {
        get: function () {
            return this.k;
        },
        set: function (a) {
            this.k = a;
            this.j.container = this.k;
        },
        enumerable: false,
        configurable: true
    });
    SRProvider.prototype.cb = function (a) {
        this.j.setBundleId(a);
    };
    Object.defineProperty(SRProvider.prototype, "b3", {
        get: function () {
            return this.j.getString("OPD_DefaultInteraction");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "b4", {
        get: function () {
            return this.j.getString("OPD_ScaleToFit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "b6", {
        get: function () {
            return this.j.getString("OPD_ZoomTo100");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "b5", {
        get: function () {
            return this.j.getString("OPD_ScaleToFit_SeriesViewer");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "b7", {
        get: function () {
            return this.j.getString("PieChart_Others");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bz", {
        get: function () {
            return this.j.getString("FinancialSeries_Open");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bw", {
        get: function () {
            return this.j.getString("FinancialSeries_Close");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "by", {
        get: function () {
            return this.j.getString("FinancialSeries_Low");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bx", {
        get: function () {
            return this.j.getString("FinancialSeries_High");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "b0", {
        get: function () {
            return this.j.getString("FinancialSeries_Volume");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "m", {
        get: function () {
            return this.j.getString("BubbleSeries_Radius");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "r", {
        get: function () {
            return this.j.getString("DataProviderNotInitialized");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "b2", {
        get: function () {
            return this.j.getString("Object_Sealed");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "b8", {
        get: function () {
            return this.j.getString("RangeModificationsNotSupported");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "s", {
        get: function () {
            return this.j.getString("Default_Series_Title");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "n", {
        get: function () {
            return this.j.getString("DataChart_InteractivityNotLoaded");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "p", {
        get: function () {
            return this.j.getString("DataChart_TrendLinesNotLoaded");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "o", {
        get: function () {
            return this.j.getString("DataChart_NumberAbbreviatorNotLoaded");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "q", {
        get: function () {
            return this.j.getString("DataChart_VisualDataNotLoaded");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ca", {
        get: function () {
            return this.j.getString("TRIAL_VERSION");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "b9", {
        get: function () {
            return this.j.getString("ScatterSeries_Value");
        },
        enumerable: false,
        configurable: true
    });
    SRProvider.prototype.b1 = function (a) {
        return this.j.getString(a);
    };
    Object.defineProperty(SRProvider.prototype, "bq", {
        get: function () {
            return this.j.getString("FinancialChart_RangeSelector_OneMonth");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bt", {
        get: function () {
            return this.j.getString("FinancialChart_RangeSelector_ThreeMonths");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bs", {
        get: function () {
            return this.j.getString("FinancialChart_RangeSelector_SixMonths");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bv", {
        get: function () {
            return this.j.getString("FinancialChart_RangeSelector_YearToDate");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "br", {
        get: function () {
            return this.j.getString("FinancialChart_RangeSelector_OneYear");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bo", {
        get: function () {
            return this.j.getString("FinancialChart_RangeSelector_All");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bp", {
        get: function () {
            return this.j.getString("FinancialChart_RangeSelector_From");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bu", {
        get: function () {
            return this.j.getString("FinancialChart_RangeSelector_To");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "t", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorMenu_Header");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "v", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorMenu_OverlaysCategoryHeader");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "w", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorMenu_TrendlinesCategoryHeader");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "x", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorMenu_VolumeCategoryHeader");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "u", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorMenu_IndicatorsCategoryHeader");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a6", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Overlay_BollingerBands");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a7", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Overlay_PriceChannel");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "y", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_AbsoluteVolumeOscillator");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "z", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_AccumulationDistribution");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "aa", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_AverageDirectionalIndex");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ab", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_AverageTrueRange");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ac", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_BollingerBandWidth");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ad", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_ChaikinOscillator");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ae", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_ChaikinVolatility");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "af", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_CommodityChannelIndex");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ag", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_DetrendedPriceOscillator");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ah", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_EaseOfMovement");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ai", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_FastStochasticOscillator");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "aj", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_ForceIndex");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ak", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_FullStochasticOscillator");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "al", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_MarketFacilitationIndex");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "am", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_MassIndex");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "an", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_MedianPrice");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ao", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_MoneyFlowIndex");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ap", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_MovingAverageConvergenceDivergence");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "aq", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_NegativeVolumeIndex");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ar", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_OnBalanceVolume");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "as", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_PercentagePriceOscillator");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "at", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_PercentageVolumeOscillator");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "au", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_PositiveVolumeIndex");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "av", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_PriceVolumeTrend");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "aw", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_RateOfChangeAndMomentum");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ax", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_RelativeStrengthIndex");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ay", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_SlowStochasticOscillator");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "az", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_StandardDeviation");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a0", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_StochRSI");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a1", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_TRIX");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a2", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_TypicalPrice");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a3", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_UltimateOscillator");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a4", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_WeightedClose");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a5", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Indicator_WilliamsPercentR");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a8", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_CubicFit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "a9", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_CumulativeAverage");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "ba", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_ExponentialAverage");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bb", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_ExponentialFit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bc", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_LinearFit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bd", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_LogarithmicFit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "be", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_ModifiedAverage");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bf", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_PowerLawFit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bg", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_QuadraticFit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bh", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_QuarticFit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bi", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_QuinticFit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bj", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_SimpleAverage");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bk", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_TrendLine_WeightedAverage");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bl", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Volume_Area");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bm", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Volume_Column");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SRProvider.prototype, "bn", {
        get: function () {
            return this.j.getString("FinancialChart_IndicatorsMenu_Volume_Line");
        },
        enumerable: false,
        configurable: true
    });
    SRProvider.$t = markType(SRProvider, 'SRProvider', DependencyObject.$);
    return SRProvider;
}(DependencyObject));
export { SRProvider };
